function AboutSiteInfo() {
  return (
    <div className="about-site-info">
      <strong>本サイトについて</strong>
      <p>このサイトでは、自身の空いている時間（参加が可能な時間）を入力してください。その中から主催者が時間を調整して連絡します。</p>
      <p>Googleログインをすることで入力内容が保存され、変更も容易となります。</p>
    </div>
  );
}

export default AboutSiteInfo;
